<template>
  <div class="base-pagination">
    <Button
      :disabled="isPreviousButtonDisabled"
      @click.native="previousPage"
      icon="icon-arrow-left">
    </Button>

    <PaginationTrigger
      v-for="paginationTrigger in paginationTriggers"
      :class="{
        'base-pagination__description--current':
        paginationTrigger === currentPage
      }"
      :key="paginationTrigger"
      :pageNumber="paginationTrigger"
      class="base-pagination__description"
      @loadPage="onLoadPage"
    />

    <Button
      :disabled="isNextButtonDisabled"
      @click.native="nextPage"
      icon="icon-arrow-right">
    </Button>
  </div>
</template>

<script>
import Button from '@/components/Button'
import PaginationTrigger from '@/components/PaginationTrigger'

export default {
  components: {
    Button,
    PaginationTrigger
  },

  props: {
    currentPage: {
      type: Number,
      required: true
    },

    pageCount: {
      type: Number,
      required: true
    },

    visiblePagesCount: {
      type: Number,
      required: true
    }
  },

  computed: {
    isPreviousButtonDisabled () {
      return this.currentPage === 1
    },

    isNextButtonDisabled () {
      return this.currentPage === this.pageCount
    },

    paginationTriggers () {
      const { currentPage, pageCount, visiblePagesCount } = this

      const paginationTriggersArray = Array.from({ length: visiblePagesCount }, (_, i) => 0)

      if (pageCount <= visiblePagesCount) {
        return paginationTriggersArray.map((_, index) => index + 1)
      }

      const visiblePagesThreshold = Math.floor(visiblePagesCount / 2)

      if (currentPage <= visiblePagesThreshold) {
        const paginationTriggers = paginationTriggersArray.map((_, index) => index + 1)
        paginationTriggers.push(pageCount)
        return paginationTriggers
      }

      if (currentPage >= pageCount - visiblePagesThreshold) {
        const paginationTriggers = paginationTriggersArray.map((_, index) => pageCount - index)
        paginationTriggers.reverse()
        paginationTriggers.unshift(1)
        return paginationTriggers
      }

      const initialValue = currentPage - visiblePagesThreshold + 1
      const paginationTriggers = paginationTriggersArray.map((_, index) => initialValue + index)
      paginationTriggers.unshift(1)
      paginationTriggers[paginationTriggers.length - 1] = pageCount
      return paginationTriggers
    }
  },

  methods: {
    nextPage () {
      this.$emit('nextPage')
    },

    onLoadPage (value) {
      this.$emit('loadPage', value)
    },

    previousPage () {
      this.$emit('previousPage')
    }
  }
}
</script>

<style lang="scss" scoped>
.base-pagination {
  display: flex;
  justify-content: center;
  align-items: center;

  &__description {
    display: flex;
    margin: 0 8px;
    font-size: 16px;
    font-weight: 600;
    width: 30px;
    height: 30px;
    justify-content: center;
    align-items: center;

    &--current {
      border-radius: 50%;
      background-color: rgba(177, 40, 30, 0.2);

    }
  }
}
</style>
